let _BASE; // API接口地址前缀
let _LocalBase;
let _UACBASE;
let _HIKMEBASE;
let _WEBSITEBASE;
let _LOGOUTBASE;
let _INTLLOGINBASE;
if (process.env.NODE_ENV === "production") {
  _WEBSITEBASE = process.env.VUE_APP_BASE_API === "intl" ? "/en/" : "/";
  _BASE = window.location.origin + _WEBSITEBASE + "api";
  _UACBASE = "https://uac.hikvision.com";
  _HIKMEBASE = "https://identity-test.hikvision.com/login";
  _LOGOUTBASE = window.location.origin + _WEBSITEBASE + "api/user/sso/logout";
  _INTLLOGINBASE = window.location.origin + "/en/user/sso/login";
  // _BASE = "http://10.1.160.173:10979";
} else {
  // 本地联调环境
  _BASE = "https://hikme-tst.hikvision.com.cn/api";
  _LocalBase = "http://10.18.84.16:8087";
  //_LocalBase = "http://10.18.84.125:8081";
  // _BASE = "http://yapi.hikvision.com/mock/9239";
  _LocalBase = "http://10.18.84.121:8089"; // guoyue
  // _BASE = "http://10.18.83.26:8085"; //zhouchen
  _UACBASE = "https://uac.hikvision.com";
}
export const BASE = _BASE;
export const LocalBase = _LocalBase;
export const UACBASE = _UACBASE;
export const HIKMEBASE = _HIKMEBASE;
export const initLanguage =
  process.env.VUE_APP_BASE_API === "intl" ? "en" : "zh";
export const LOGOUTBASE = _LOGOUTBASE;
export const INTLLOGINBASE = _INTLLOGINBASE;
